import { spacingTokens } from './spacing';
import { colorBackgroundDefaultTokens, colorBorderDefaultTokens, colorTextDefaultTokens } from './color';
const tokenList = Object.freeze({
    ...spacingTokens,
    ...colorBackgroundDefaultTokens,
    ...colorBorderDefaultTokens,
    ...colorTextDefaultTokens
});
export default tokenList;
//# sourceMappingURL=token-list.js.map